import { ReactElement } from 'react'
import FormCollapsibleSection from './FormCollapsibleSection'
import { CollapsibleBoxSectionProps } from './collapsibleSectionProps'
import { FormSectionIcons } from './icons'

interface Props extends CollapsibleBoxSectionProps {
  label: string
}

const CollapsibleActionsBoxSection = ({
  children,
  label = 'Aktionen',
  defaultExpanded = true,
  dataCy,
  isEmpty,
}: Props): ReactElement | null => {
  return (
    <FormCollapsibleSection
      label={label}
      startIcon={FormSectionIcons.actions}
      defaultExpanded={defaultExpanded}
      dataCy={dataCy}
      isEmpty={isEmpty}
    >
      {children}
    </FormCollapsibleSection>
  )
}

export default CollapsibleActionsBoxSection
